<template>
  <div>
    <div class="page-wrapper">
      <div class="">
        <div
          class="page-content"
          v-show="accessObject?.is_view == 1 || !isShowAccessDeniedMessage">
          <div class="card-body py-0 px-2">
            <div class="mb-0 radius-15">
              <!-- card border -->

              <div class="row tablefix">
                <div class="col-lg-2 col-sm-2 pr-2 my-auto">
                  <span class="pull-left">
                    <a
                      class="pr-2 text-dark cursor-pointer"
                      v-on:click="$router.go(-1)"
                      ><span class="font-24 mr-2"
                        ><img src="/images/back-arrow.svg" width="18"
                      /></span>
                    </a>
                  </span>
                  <span class="has-search pull-left" style="width: 80%">
                    <!-- <span class="bx bx-search form-control-feedback"></span> -->
                    <i
                      class="fa fa-search"
                      style="position: absolute; margin: 10px"
                      aria-hidden="true"></i>
                    <input
                      type="text"
                      style="color: #bd1c9c; cursor: pointer"
                      class="form-control"
                      placeholder="Search "
                      v-model="searchObj.keyword"
                      v-on:keyup.enter="getList(0)" />
                  </span>
                </div>
                <div class="col-lg-2 col-sm-2 my-auto">
                  <div class="styled-select">
                    <select
                      class="form-control"
                      v-on:change="getList(0)"
                      v-model="searchObj.membership_plan_id"
                      name=""
                      aria-required="true"
                      placeholder="Select Plan"
                      aria-invalid="false">
                      <option value="" disabled selected="selected">
                        Select Plan
                      </option>
                      <option value="FREE_MEMBER">Free Member</option>
                      <option
                        v-for="(data, index) in planList"
                        :key="index"
                        :value="data.uuid">
                        {{ data.name }}
                      </option>
                    </select>
                    <span
                      class="bx bx-chevron-down"
                      style="top: 6px; right: 8px"></span>
                  </div>
                </div>
                <div class="col-lg-5 col-sm-4 my-auto">
                  <a
                    style="display: inline-block"
                    class="fill-btn btn-style cursor-pointer ml-3"
                    v-on:click="getList(0)"
                    >Search</a
                  >
                  <a
                    style="display: inline-block"
                    class="fill-btn btn-style cursor-pointer"
                    v-on:click="resetFilter()"
                    >Reset</a
                  >
                  <span style="font-weight: Bold" class="mr-2">
                    Gun Milan:
                    <span style="color: #f70cbc">{{
                      gun_milan ? gun_milan : "0"
                    }}</span>
                  </span>

                  <span style="font-weight: Bold" class="mr-2">
                    Dosh kramank :
                    <span style="color: #f70cbc">{{
                      dosh_kramank
                        ? dosh_kramank.length > 1 && dosh_kramank != "NA"
                          ? dosh_kramank
                          : dosh_kramank
                        : "0"
                    }}</span>
                  </span>

                  <span style="font-weight: Bold" class="mr-0">
                    Mangal :
                    <span style="color: #f70cbc">{{
                      is_mangal ? is_mangal : "NA"
                    }}</span>
                  </span>
                </div>
                <div class="col-lg-3 col-sm-4">
                  <div class="text-last">
                    <div>
                      <ul class="navbar-nav">
                        <li class="nav-item dropdown dropdown-user-profile">
                          <a
                            class="nav-link dropdown-toggle dropdown-toggle-nocaret pr-0"
                            style="border-color: white; outline: 0"
                            data-toggle="dropdown">
                            <a class="fill-btn btn-style cursor-pointer"
                              ><i class="fa fa-paper-plane"></i>&nbsp; Send To
                              Account</a
                            >
                          </a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                               v-on:click="sendToAccount('ONEWAY')"
                              class="dropdown-item cursor-pointer">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-paper-plane"></i>&nbsp;Send One Way
                              </span>
                            </a>
                             <a
                               v-on:click="sendToAccount('TWOWAY')"
                              class="dropdown-item cursor-pointer">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-paper-plane"></i>&nbsp;Send Two Way
                              </span>
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <ul class="navbar-nav">
                        <li class="nav-item dropdown dropdown-user-profile">
                          <a
                            class="nav-link dropdown-toggle dropdown-toggle-nocaret pr-0"
                            style="border-color: white; outline: 0"
                            data-toggle="dropdown">
                            <a class="fill-btn btn-style cursor-pointer"
                              ><i class="fa fa-download"></i>&nbsp; Download
                              PDF</a
                            >
                          </a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              v-on:click="downloadProfile()"
                              class="dropdown-item cursor-pointer">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-download"></i>&nbsp;Personal
                                Bio-Data
                              </span>
                            </a>
                            <div
                              class="dropdown-divider mb-0 cursor-pointer"></div>
                            <a
                              :class="
                                suggested_user_ids.length == 0
                                  ? 'cursor-drop'
                                  : 'cursor-pointer'
                              "
                              :style="
                                suggested_user_ids.length == 0
                                  ? 'opacity: 0.5;'
                                  : 'opacity: 1'
                              "
                              v-on:click="
                                suggested_user_ids.length == 0
                                  ? ''
                                  : getSuggestedUsersDetailPdf()
                              "
                              class="dropdown-item">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-download"></i>&nbsp;Suggested
                                Detailed Bio-Data (All Details)
                              </span>
                            </a>
                            <div
                              class="dropdown-divider mb-0 cursor-pointer"></div>
                            <a
                              :class="
                                suggested_user_ids.length == 0
                                  ? 'cursor-drop'
                                  : 'cursor-pointer'
                              "
                              :style="
                                suggested_user_ids.length == 0
                                  ? 'opacity: 0.5;'
                                  : 'opacity: 1'
                              "
                              v-on:click="
                                suggested_user_ids.length == 0
                                  ? ''
                                  : downloadPdf()
                              "
                              class="dropdown-item">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-download"></i>&nbsp;Summary
                                List</span
                              >
                            </a>
                            <div
                              class="dropdown-divider mb-0 cursor-pointer"></div>
                            <a
                              :class="
                                suggested_user_ids.length == 0
                                  ? 'cursor-drop'
                                  : 'cursor-pointer'
                              "
                              :style="
                                suggested_user_ids.length == 0
                                  ? 'opacity: 0.5;'
                                  : 'opacity: 1'
                              "
                              v-on:click="
                                suggested_user_ids.length == 0
                                  ? ''
                                  : getSuggestedUsersDetailWithoutContactPdf()
                              "
                              class="dropdown-item">
                              <!-- <i class="bx bx-user"></i> -->
                              <span
                                ><i class="fa fa-download"></i>&nbsp; Suggested
                                Detailed Bio-Data (Without Contact
                                Details)</span
                              >
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt40">
                <div
                  class="col-lg-12 col-sm-12 my-2"
                  v-if="detail && detail.id">
                  <span
                    class="mb-0 cursor-pointer"
                    style="
                      color: rgb(232, 62, 140);
                      font-size: 20px;
                      font-weight: Bold;
                    "
                    v-on:click="
                      goToUrl(
                        detail.id,
                        '/view-user-detail/' + detail.uuid + '/SHORT'
                      )
                    ">
                    Matches for {{ detail.registration_no }} |
                  </span>
                  <span>
                    <img
                      :src="detail.image ? detail.image : '/img/user-pic.png'"
                      class="user-img"
                      alt=""
                      id="loginuser-image" />
                  </span>
                  <span style="font-size: 20px; font-weight: Bold">
                    &nbsp; {{ detail.first_name }} {{ detail.last_name }} |
                  </span>

                  <span style="font-size: 20px; font-weight: Bold">
                    &nbsp;
                    {{
                      (detail.dob
                        ? $helperService.getNewFormatedDate(detail.dob) + " | "
                        : "") +
                      (detail.height
                        ? $helperService.getHeight(detail.height) + " | "
                        : "") +
                      (detail.annual_income
                        ? detail.annual_income + " | "
                        : "") +
                      (detail.blood_group ? detail.blood_group + " | " : "") +
                      (detail.personality
                        ? detail.personality.name + " | "
                        : "") +
                      (detail.family_details && detail.family_details.eco_status
                        ? detail.family_details.eco_status.name + " | "
                        : "") +
                      (detail.family_details && detail.family_details.relation
                        ? detail.family_details.relation.name + " | "
                        : "")
                    }}
                  </span>
                </div>
              </div>

              <div>
                <div class="card mb-0 radius-15 mt-1 custom-table">
                  <div class="card-body p-0 pb-4">
                    <div class="table-responsive">
                      <div class="dataTables_wrapper dt-bootstrap4">
                        <div class="tableFixHead">
                          <table
                            class="table table-striped table-bordered"
                            role="grid"
                            aria-describedby="example_info">
                            <thead>
                              <tr role="row">
                                <th></th>
                                <th
                                  class="sorting widID"
                                  id="id-contacts_viewed"
                                  v-on:click="
                                    sorting(
                                      'users.registration_no',
                                      'id-contacts_viewed'
                                    )
                                  ">
                                  <div>ID</div>
                                </th>
                                <th
                                  class="sorting"
                                  id="id-user_subscription_plan_histories_amount"
                                  v-on:click="
                                    sorting(
                                      'am.amount',
                                      'id-user_subscription_plan_histories_amount'
                                    )
                                  ">
                                  <div>Rs</div>
                                </th>
                                <th
                                  class="sorting"
                                  id="id-echo_status_name"
                                  v-on:click="
                                    sorting('echo.name', 'id-echo_status_name')
                                  ">
                                  <div>ES</div>
                                </th>
                                <th
                                  class="sorting"
                                  id="id-personality_name"
                                  v-on:click="
                                    sorting(
                                      'master.name',
                                      'id-personality_name'
                                    )
                                  ">
                                  <div>P</div>
                                </th>
                                <th
                                  style="width: 75px"
                                  class="sorting"
                                  id="id-first_name"
                                  v-on:click="
                                    sorting('users.first_name', 'id-first_name')
                                  ">
                                  <div>F. Name</div>
                                </th>
                                <th
                                  style="width: 75px"
                                  class="sorting"
                                  id="id-middle_name"
                                  v-on:click="
                                    sorting(
                                      'users.middle_name',
                                      'id-middle_name'
                                    )
                                  ">
                                  <div>M. Name</div>
                                </th>
                                <th
                                  style="width: 100px"
                                  class="sorting"
                                  id="id-last_name"
                                  v-on:click="
                                    sorting('users.last_name', 'id-last_name')
                                  ">
                                  <div>Surname</div>
                                </th>
                                <th
                                  style="color: #bd1c9c; cursor: pointer"
                                  class="sorting"
                                  id="id-minus_point"
                                  v-on:click="
                                    sorting(
                                      'users.minus_point',
                                      'id-minus_point'
                                    )
                                  ">
                                  <div>MP</div>
                                </th>
                                <th
                                  style="color: #bd1c9c; cursor: pointer"
                                  class="sorting nativewidth1"
                                  id="id-native_place_taluka_name"
                                  v-on:click="
                                    sorting(
                                      'native.name',
                                      'id-native_place_taluka_name'
                                    )
                                  ">
                                  <div>Native<br />Dist + Tal</div>
                                </th>

                                <th
                                  class="sorting famwidth1"
                                  id="id-taluka"
                                  v-on:click="
                                    sorting(
                                      'family_residence_talukas.name',
                                      'id-taluka'
                                    )
                                  "
                                  style="width: 150px">
                                  <div>Family Res. <br />Tal + A/G</div>
                                </th>
                                <th
                                  style="width: 120px"
                                  class="sorting"
                                  id="id-working_place_taluka_name"
                                  v-on:click="
                                    sorting(
                                      'working.name',
                                      'id-working_place_taluka_name'
                                    )
                                  ">
                                  <div>Work Location</div>
                                </th>

                                <th
                                  style="color: #bd1c9c; cursor: pointer"
                                  class="sorting"
                                  id="id-aaaa"
                                  v-on:click="
                                    sorting('users.annual_income', 'id-aaaa')
                                  ">
                                  <div>Inc.</div>
                                  <div>(Lac)</div>
                                </th>
                                <th
                                  style="width: 250px"
                                  class="sorting eudwid"
                                  id="id-education"
                                  v-on:click="
                                    sorting(
                                      'users.education_courses',
                                      'id-education'
                                    )
                                  ">
                                  <div>Education</div>
                                </th>
                                <th
                                  class="sorting dobwid"
                                  id="id-dob"
                                  v-on:click="sorting('users.dob', 'id-dob')">
                                  DOB
                                </th>
                                <th
                                  style="color: #bd1c9c; cursor: pointer"
                                  class="sorting"
                                  id="id-height"
                                  v-on:click="
                                    sorting('users.height', 'id-height')
                                  ">
                                  <div>HT.</div>
                                </th>
                                <th
                                  style="color: #bd1c9c; cursor: pointer"
                                  class="sorting"
                                  id="id-SD"
                                  v-on:click="
                                    sorting(
                                      'handpick_suggestions.created_at',
                                      'id-SD'
                                    )
                                  ">
                                  Expectations | Patrika | SD
                                </th>
                              </tr>
                            </thead>
                            <tbody v-show="!loader">
                              <tr v-for="(data, index) in list" :key="index">
                                <td
                                  @click="
                                    sendToSuggestion(
                                      data,
                                      data.is_checked,
                                      index
                                    )
                                  "
                                  style="cursor: pointer"
                                  :id="'short_' + data.id"
                                  :style="
                                    data.is_membership_subscribed == null ||
                                    data.is_membership_subscribed == 'N'
                                      ? 'background-color: rgb(210, 242, 210);'
                                      : 'white'
                                  ">
                                  <div class="switchToggleRead">
                                    <!-- :disabled="data.is_checked == true ? false : (this.suggested_user_ids.length >=2 ? true : false)" -->
                                    <input
                                      :key="'index_' + index + '_' + data.id"
                                      :id="'index_' + data.id"
                                      type="checkbox"
                                      :v-model="data.is_checked"
                                      :true-value="true"
                                      :false-value="false"
                                      @click.stop="
                                        sendToSuggestion(
                                          data,
                                          data.is_checked,
                                          index
                                        )
                                      " />
                                  </div>
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  class=""
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{ data.registration_no }}</span
                                  >
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  class=""
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.amount
                                        ? $helperService.kThousandFormatter(
                                            data.amount
                                          )
                                        : "0k"
                                    }}</span
                                  >
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  class=""
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.echo_status_name
                                        ? data.echo_status_name
                                        : "-"
                                    }}</span
                                  >
                                </td>

                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  class=""
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.personality_name
                                        ? data.personality_name
                                        : "-"
                                    }}</span
                                  >
                                </td>

                                <td
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                  "
                                  class=""
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <a>
                                    <span
                                      style="
                                        font-weight: 600;
                                        color: rgb(232, 62, 140);
                                        font-size: 13px;
                                      "
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      "
                                      >{{
                                        data.first_name ? data.first_name : "-"
                                      }}</span
                                    >

                                    <div class="">
                                      <img
                                        class="picWidth"
                                        @click="viewImage(data.image)"
                                        :src="
                                          data.image
                                            ? data.image
                                            : '/images/user-pic.png'
                                        "
                                        width="40"
                                        height="40" />
                                    </div>
                                  </a>
                                </td>
                                <td
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                    color: #bd1c9c;
                                  "
                                  class=""
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.middle_name ? data.middle_name : "-"
                                    }}</span
                                  >
                                </td>
                                <td
                                  v-on:click="
                                    goToUrl(
                                      data.id,
                                      '/view-user-detail/' +
                                        data.uuid +
                                        '/SHORT'
                                    )
                                  "
                                  style="color: #bd1c9c; cursor: pointer"
                                  class=""
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    style="
                                      font-weight: 600;
                                      color: rgb(232, 62, 140);
                                      font-size: 13px;
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.last_name ? data.last_name : "-"
                                    }}</span
                                  >
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.minus_point ? data.minus_point : "-"
                                    }}</span
                                  >
                                </td>
                                <td
                                  class="cursor-pointer"
                                  v-on:click="kundliMilan(data.uuid, uuid)"
                                  style="
                                    font-weight: 600;
                                    color: rgb(232, 62, 140);
                                    font-size: 13px;
                                    color: #bd1c9c;
                                  "
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.native_place_taluka_name
                                        ? data.native_place_taluka_name + ", "
                                        : "-"
                                    }}</span
                                  >
                                  <br />
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.native_place_goan
                                        ? data.native_place_goan
                                        : ""
                                    }}
                                  </span>
                                </td>
                                <td
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                    color: #bd1c9c;
                                  "
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.talukas_name
                                        ? data.talukas_name + ", "
                                        : "-"
                                    }}</span
                                  >
                                  <br />
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{ data.goan ? data.goan : "" }}
                                  </span>
                                </td>
                                <td
                                  class=""
                                  style="color: #bd1c9c; cursor: pointer"
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.working_place_taluka_name
                                        ? data.working_place_taluka_name + ", "
                                        : "-"
                                    }}</span
                                  >
                                  <br />
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.working_place_goan
                                        ? data.working_place_goan
                                        : ""
                                    }}
                                  </span>
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  class=""
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.annual_income ||
                                      data.annual_income == 0
                                        ? this.$helperService.kFormatter(
                                            data.annual_income
                                          )
                                        : ""
                                    }}</span
                                  >
                                </td>
                                <td
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                    color: #bd1c9c;
                                  "
                                  class=""
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                    >{{ data.education_courses }}</span
                                  >
                                </td>

                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  class=""
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.dob
                                        ? $helperService.getFormatedDateNew(
                                            data.dob
                                          )
                                        : "-"
                                    }}</span
                                  >
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      $helperService.getHeight(data.height)
                                        ? $helperService.getHeight(data.height)
                                        : "-"
                                    }}</span
                                  >
                                </td>
                                <td
                                  style="
                                    word-break: break-all !important;
                                    word-wrap: break-word;
                                    color: #bd1c9c;
                                  "
                                  :style="
                                    data.handpicked_id
                                      ? 'background-color: #ffff0042;'
                                      : ''
                                  ">
                                  <span
                                    v-if="
                                      data.expectation &&
                                      data.expectation.patrika_match
                                    "></span>
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    v-if="
                                      data.expectation &&
                                      data.expectation
                                        .occupation_other_expectations
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.expectation &&
                                      data.expectation
                                        .occupation_other_expectations
                                        ? " " +
                                          data.expectation
                                            .occupation_other_expectations +
                                          " "
                                        : ""
                                    }}
                                  </span>
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    v-if="
                                      data.expectation &&
                                      data.expectation
                                        .occupation_other_expectations
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                    >|</span
                                  ><br />
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    v-if="
                                      data.expectation &&
                                      data.expectation.patrika_match
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.expectation &&
                                      data.expectation.patrika_match
                                        ? data.expectation.patrika_match == "Y"
                                          ? "YES "
                                          : data.expectation.patrika_match ==
                                            "N"
                                          ? "NO "
                                          : data.expectation.patrika_match ==
                                            "ALL"
                                          ? "Flexible"
                                          : ""
                                        : ""
                                    }}
                                  </span>
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    v-if="data.suggested_date"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                    >|</span
                                  ><br />
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.suggested_date
                                        ? " " +
                                          $helperService.getFormatedDateNew(
                                            data.suggested_date
                                          )
                                        : "-"
                                    }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="row mx-0 mb-4">
                            <div class="col-lg-12 mt-2 text-center">
                              <div class="page-bottom-pagination text-right">
                                <Pagination
                                  @page-change="pageChange"
                                  @items-per-page-change="itemsPerPageChange"
                                  ref="listPagination" />
                              </div>
                            </div>
                          </div>
                          <ErrorComponent
                            @retry="getList(0)"
                            ref="errorComponent" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div style="display: none">
                <div class="mb-0 radius-15">
                  <div class="card-body p-0 pb-4">coming soon</div>
                </div>
              </div>
              <div class="row mx-0 mb-4">
                <div class="col-lg-12 mt-5 text-center">
                  <div class="page-bottom-pagination text-right">
                    <Pagination
                      @page-change="pageChange"
                      @items-per-page-change="itemsPerPageChange"
                      ref="listPagination"
                    />
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal @remove="accept($event)" ref="hideModal" />
    <DeleteModal @remove="deleteRecord($event)" ref="deleteModal" />
    <TextModal ref="viewImage">
      <div
        class="modal-header border-0 d-block text-center"
        style="position: relative">
        <a
          class="close text-danger btn-pos"
          style="opacity: 1"
          v-on:click="$refs.viewImage.closeModal()">
          <img
            src="/images/close-btn.png"
            width="25"
            height="25"
            style="background: #fff; border-radius: 100px" />
        </a>
        <img
          :src="module_image"
          :id="compoentId"
          class="mg-fluid thumbnail-img profile-pic" />
      </div>
    </TextModal>
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import DeleteModal from "@/components/DeleteModal";
import TextModal from "@/components/TextModal.vue";
export default {
  name: "ShortList",
  components: {
    ErrorComponent,
    DeleteModal,
    Pagination,
    TextModal,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Manage Users"),
      uuid: this.$route.params.uuid,
      loader: true,
      isShowAccessDeniedMessage: false,
      gun_milan: "",
      dosh_kramank: "",
      is_mangal: "",
      searchObj: {
        keyword: "",
        membership_plan_id: "",
        uuid: this.$route.params.uuid,
        type: "SHORT",
      },
      suggested_user_ids: [],
      detail: {},
      count: 0,
      offset: -1,
      list: [],
      planList: [],
    };
  },
  mounted() {
    // if (!this.accessObject) {
    //   this.isShowAccessDeniedMessage = true;
    //   this.$router.push("/access-denied");
    //   return;
    // }
    this.getList(0);
    this.getPlanList();
    this.$helperService.showMenu("false");
  },
  methods: {
    viewImage(url) {
      if (url) {
        this.module_image = url;
        this.$refs.viewImage.showModal("HIDE");
      }
    },
    changeTab(tab) {
      this.currentTab = tab;
      this.searchObj.keyword = "";
      this.getList(0);
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getPlanList() {
      this.$api
        .getAPI({
          _action: "/plan/list",
        })
        .then((res) => {
          this.planList = res.list;
        })
        .catch(() => {});
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    goToUrl(id, url) {
      var obj = {};
      obj.id = "short_" + id;
      obj.offset = this.searchObj.offset;
      // this.$shareService.setMapValue("short_lists", obj);
      // this.$router.push(url);
      window.open(
        url,
        "mywindow",
        "menubar=1,resizable=1,width=3500,height=1300"
      );
    },
    sendToAccount(type) {
      if (this.suggested_user_ids.length == 0) {
        this.$notify({
          type: "error",
          text: "Please select atleast one user",
        });
        return;
      }
      this.$refs.errorComponent.updateFormLoader(true);
      var obj = {};
      obj.uuid = this.$route.params.uuid;
      obj.suggested_user_ids = this.suggested_user_ids;
      obj.type = type;
      this.$api
        .postAPI({
          _action: "/suggest",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.status,
          });
          // this.suggested_user_ids = [];
          this.$refs.errorComponent.updateFormLoader(false);
          this.getList(this.searchObj.offset, "", "", "TYPE");
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    getList(page, orderBy, sortBy, type) {
      this.$refs.errorComponent.updateListLoader(true);
      this.loader = true;
      // this.list = [];
      // this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      var shareobj = this.$shareService.getMapValue("short_lists")
        ? this.$shareService.getMapValue("short_lists")
        : null;
      this.searchObj.offset =
        shareobj && shareobj.offset ? shareobj.offset : page;
      this.$api
        .getAPI({
          _action: "/sugestion/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.detail = res.user;
          if (res.list && res.list.length > 0) {
            for (var i in res.list) {
              res.list[i].is_checked = false;
            }
          }
          this.list = res.list;
          this.count = res.count;
          this.offset = res.next_offset;
          if (this.suggested_user_ids && this.suggested_user_ids.length > 0) {
            setTimeout(() => {
              for (var k in res.list) {
                for (var j in this.suggested_user_ids) {
                  if (this.suggested_user_ids[j].uuid == res.list[k].uuid) {
                    res.list[k].is_checked = true;
                    document.getElementById(
                      "index_" + res.list[k].id
                    ).checked = true;
                  }
                }
              }
            }, 1000);
          } else if (type == "TYPE") {
            this.suggested_user_ids = [];
            for (var k in res.list) {
              res.list[k].is_checked = false;
              document.getElementById(
                "index_" + res.list[k].id
              ).checked = false;
            }
          }
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count, 50);
                this.$refs.listPagination.setCurrentPage(
                  this.searchObj.offset + 1
                );
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }

          if (shareobj && shareobj.id) {
            setTimeout(() => {
              document.getElementById(shareobj.id).scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              });
            }, 100);
          } else {
            if (res.list && res.list.length > 0 && res.list[0].id) {
              setTimeout(() => {
                document
                  .getElementById("short_" + res.list[0].id)
                  .scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                  });
              }, 100);
            }
          }
          this.$shareService.setMapValue("short_lists", null);
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Short List Available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    sendToSuggestion(data, isChecked, index) {
      if (this.suggested_user_ids.length >= 200) {
        for (let u in this.list) {
          if (
            this.list[u].uuid == data.uuid &&
            this.list[u].is_checked == true
          ) {
            this.list[u].is_checked = false;
            for (let i in this.suggested_user_ids) {
              if (this.suggested_user_ids[i].uuid == data.uuid) {
                this.suggested_user_ids.splice(i, 1);
              }
            }
          }
        }
        // this.suggested_user_ids = [];
        for (let u in this.list) {
          if (this.list[u].is_checked == true) {
            var obj = {};
            obj.uuid = this.list[u].uuid;
            this.suggested_user_ids.push(obj);
          }
        }
        if (this.suggested_user_ids.length >= 200) {
          this.$notify({
            type: "error",
            text: "You can select maximum 200 users only.",
          });
        }
        document.getElementById("index_" + data.id).checked = false;
        this.suggested_user_ids = this.suggested_user_ids.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.uuid === item.uuid)
        );
        return;
      }
      var is_checked = !isChecked;

      if (is_checked) {
        document.getElementById("index_" + data.id).checked = true;
        this.list[index].is_checked = true;
      } else {
        document.getElementById("index_" + data.id).checked = false;
        this.list[index].is_checked = false;
        for (var i in this.suggested_user_ids) {
          if (this.suggested_user_ids[i].uuid == data.uuid) {
            this.suggested_user_ids.splice(i, 1);
          }
        }
      }
      // this.suggested_user_ids = [];
      for (var u in this.list) {
        if (this.list[u].is_checked == true) {
          let obj = {};
          obj.uuid = this.list[u].uuid;
          this.suggested_user_ids.push(obj);
        }
      }
      // Remove duplicate uuids from suggested_user_ids
      this.suggested_user_ids = this.suggested_user_ids.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.uuid === item.uuid)
      );
    },

    resetFilter() {
      this.searchObj.keyword = "";
      this.searchObj.membership_plan_id = "";
      this.getList(0);
    },
    onclick(data) {
      document.getElementById("index_" + data.id).click();
    },
    kundliMilan($user_id, $uuid) {
      this.gun_milan = "";
      this.dosh_kramank = "";
      this.is_mangal = "";
      var obj = {};
      obj.to_user_id = $user_id;
      obj.from_user_id = $uuid;
      this.$api
        .getAPI({
          _action: "/kundali/milan",
          _body: obj,
        })
        .then((res) => {
          this.gun_milan = res.gun_milan;
          if (res?.dosh_kramank != "NA") {
            this.dosh_kramank = res?.dosh_kramank?.toString();
            this.dosh_kramank = this.dosh_kramank?.replaceAll("", ",");
            this.dosh_kramank = this.dosh_kramank?.replace(/^,|,$/g, "");
          }
          this.is_mangal = res.is_mangal;
        })
        .catch(() => {});
    },

    downloadProfile() {
      var url =
        this.$api.getBaseUrl() + "/get/biodata?uuid=" + this.detail.uuid;
      if (this.detail.uuid) {
        window.open(url);
      }
    },
    downloadPdf() {
      var suggested_user_ids = [];
      for (var i in this.suggested_user_ids) {
        suggested_user_ids.push(this.suggested_user_ids[i].uuid);
      }
      var url =
        this.$api.getBaseUrl() +
        "/all/sugestion/short/list?uuids=" +
        suggested_user_ids +
        "&uuid=" +
        this.uuid;
      console.log(url);
      window.open(url);
    },
    getSuggestedUsersDetailPdf() {
      var suggested_user_ids = [];
      for (var i in this.suggested_user_ids) {
        suggested_user_ids.push(this.suggested_user_ids[i].uuid);
      }
      var url =
        this.$api.getBaseUrl() +
        "/get/all/suggested/users/biodata?uuids=" +
        suggested_user_ids +
        "&uuid=" +
        this.uuid;
      console.log(url);
      window.open(url);
    },
    getSuggestedUsersDetailWithoutContactPdf() {
      // if (this.suggested_user_ids.length > 0) {
      //   var array = [];
      //   for (var i in this.suggested_user_ids) {
      //     array.push(this.suggested_user_ids[i].uuid);
      //   }
      //   var uuids = array.toString();
      // } else {
      //   this.$notify({
      //     type: "error",
      //     text: "Please select the user first to download pdf",
      //   });
      //   return;
      // }
      var suggested_user_ids = [];
      for (var i in this.suggested_user_ids) {
        suggested_user_ids.push(this.suggested_user_ids[i].uuid);
      }
      var url =
        this.$api.getBaseUrl() +
        "/get/all/suggested/users/biodata-without-contact?uuids=" +
        suggested_user_ids +
        "&uuid=" +
        this.uuid;
      window.open(url);
    },
  },
};
</script>

<style>
input[type="checkbox"],
input[type="radio"] {
  width: 20px;
  height: 18px;
}
</style>
